import React from 'react'
import './Navbar.css'
import AccordionList from "../FAV/AccorLI";
import Navbar from './Navb';


const About = () => {
  return (
    <div className='nnnm'>
      <Navbar/>
  
        <AccordionList className='red'/>
     
    
    </div>
    
  )
}

export default About
